<template>
  <power-bi code="eyJrIjoiNDU5NTBhNjYtMjQ3OC00NmJhLTk0ZDgtYTQ2NTdlOWVlZWIzIiwidCI6ImM4NDJjMWQ5LWQzNjQtNDcxNi1iN2UzLWNhNDgxYTIzZDZhYyJ9" />
</template>

<script>
import PowerBi from '../components/PowerBi.vue';

export default {
    components: {
        PowerBi,
    },
};
</script>
